module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.salons) ? _c('div', {
    staticClass: "tabs-stocks panel panel-default"
  }, [_c('form', {
    staticClass: "form-stock",
    attrs: {
      "role": "form",
      "action": ("/required-fields/" + _vm.salon_id),
      "method": "POST"
    }
  }, [_c('div', {
    staticClass: "stocks-head"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.role_supervisor == 0) ? _c('h2', [_vm._v("Выберите автосалон")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Название автосалона")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salon_id),
      expression: "salon_id"
    }],
    staticClass: "salon_id form-control",
    attrs: {
      "disabled": _vm.role_supervisor != 0 ? true : false,
      "name": "salon_id"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.salon_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.salonCheck]
    }
  }, _vm._l((_vm.salons), function(salon) {
    return _c('option', {
      domProps: {
        "value": ("" + (salon.id)),
        "selected": salon.id == _vm.role_supervisor ? true : false
      }
    }, [_vm._v(_vm._s(salon.name) + "\n                    ")])
  }))])]), _vm._v(" "), _c('input', {
    attrs: {
      "name": "_method",
      "value": "PUT",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "_token",
      "type": "hidden"
    },
    domProps: {
      "value": ("" + _vm.csrf_token)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "required-tab-white"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "equipment-bordered"
  }, [_c('table', {
    staticClass: "table table-striped striped-table-inspection"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Фамилия")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.first_name),
      expression: "client.first_name"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-first_name",
      "name": "client[first_name]"
    },
    domProps: {
      "value": _vm.client.first_name,
      "checked": Array.isArray(_vm.client.first_name) ? _vm._i(_vm.client.first_name, _vm.client.first_name) > -1 : (_vm.client.first_name)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.client.first_name,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.client.first_name,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.client.first_name = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.client.first_name = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.client.first_name = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Имя")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.second_name),
      expression: "client.second_name"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-second_name",
      "name": "client[second_name]"
    },
    domProps: {
      "value": _vm.client.second_name,
      "checked": Array.isArray(_vm.client.second_name) ? _vm._i(_vm.client.second_name, _vm.client.second_name) > -1 : (_vm.client.second_name)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.client.second_name,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.client.second_name,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.client.second_name = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.client.second_name = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.client.second_name = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Отчество")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.middle_name),
      expression: "client.middle_name"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-middle_name",
      "name": "client[middle_name]"
    },
    domProps: {
      "value": _vm.client.middle_name,
      "checked": Array.isArray(_vm.client.middle_name) ? _vm._i(_vm.client.middle_name, _vm.client.middle_name) > -1 : (_vm.client.middle_name)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.client.middle_name,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.client.middle_name,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.client.middle_name = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.client.middle_name = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.client.middle_name = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Почта")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.email),
      expression: "client.email"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-email",
      "name": "client[email]"
    },
    domProps: {
      "value": _vm.client.email,
      "checked": Array.isArray(_vm.client.email) ? _vm._i(_vm.client.email, _vm.client.email) > -1 : (_vm.client.email)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.client.email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.client.email,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.client.email = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.client.email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.client.email = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Телефон")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.phone),
      expression: "client.phone"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-phone",
      "name": "client[phone]"
    },
    domProps: {
      "value": _vm.client.phone,
      "checked": Array.isArray(_vm.client.phone) ? _vm._i(_vm.client.phone, _vm.client.phone) > -1 : (_vm.client.phone)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.client.phone,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.client.phone,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.client.phone = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.client.phone = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.client.phone = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Шаг диагностики (фото)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.diagnostics),
      expression: "client.diagnostics"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-diagnostics",
      "name": "client[diagnostics]"
    },
    domProps: {
      "value": _vm.client.diagnostics,
      "checked": Array.isArray(_vm.client.diagnostics) ? _vm._i(_vm.client.diagnostics, _vm.client.diagnostics) > -1 : (_vm.client.diagnostics)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.client.diagnostics,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.client.diagnostics,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.client.diagnostics = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.client.diagnostics = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.client.diagnostics = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(6)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "equipment-bordered"
  }, [_c('table', {
    staticClass: "table table-striped striped-table-inspection"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Количество мест")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main.seat_count),
      expression: "main.seat_count"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-seat_count",
      "name": "main[seat_count]"
    },
    domProps: {
      "value": _vm.main.seat_count,
      "checked": Array.isArray(_vm.main.seat_count) ? _vm._i(_vm.main.seat_count, _vm.main.seat_count) > -1 : (_vm.main.seat_count)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.main.seat_count,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.main.seat_count,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.main.seat_count = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.main.seat_count = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.main.seat_count = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Цвет кузова")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main.color_id),
      expression: "main.color_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-main_color_id",
      "name": "main[color_id]"
    },
    domProps: {
      "value": _vm.main.color_id,
      "checked": Array.isArray(_vm.main.color_id) ? _vm._i(_vm.main.color_id, _vm.main.color_id) > -1 : (_vm.main.color_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.main.color_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.main.color_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.main.color_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.main.color_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.main.color_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Рабочий объем (см3)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main.engine_capacity),
      expression: "main.engine_capacity"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-engine_capacity",
      "name": "main[engine_capacity]"
    },
    domProps: {
      "value": _vm.main.engine_capacity,
      "checked": Array.isArray(_vm.main.engine_capacity) ? _vm._i(_vm.main.engine_capacity, _vm.main.engine_capacity) > -1 : (_vm.main.engine_capacity)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.main.engine_capacity,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.main.engine_capacity,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.main.engine_capacity = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.main.engine_capacity = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.main.engine_capacity = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Количество владельцев")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main.number_owners),
      expression: "main.number_owners"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-number_owners",
      "name": "main[number_owners]"
    },
    domProps: {
      "value": _vm.main.number_owners,
      "checked": Array.isArray(_vm.main.number_owners) ? _vm._i(_vm.main.number_owners, _vm.main.number_owners) > -1 : (_vm.main.number_owners)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.main.number_owners,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.main.number_owners,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.main.number_owners = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.main.number_owners = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.main.number_owners = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(11)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Гарантия")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main.guarantee),
      expression: "main.guarantee"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-guarantee",
      "name": "main[guarantee]"
    },
    domProps: {
      "value": _vm.main.guarantee,
      "checked": Array.isArray(_vm.main.guarantee) ? _vm._i(_vm.main.guarantee, _vm.main.guarantee) > -1 : (_vm.main.guarantee)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.main.guarantee,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.main.guarantee,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.main.guarantee = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.main.guarantee = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.main.guarantee = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Покупка в кредит")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main.purchase),
      expression: "main.purchase"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-purchase",
      "name": "main[purchase]"
    },
    domProps: {
      "value": _vm.main.purchase,
      "checked": Array.isArray(_vm.main.purchase) ? _vm._i(_vm.main.purchase, _vm.main.purchase) > -1 : (_vm.main.purchase)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.main.purchase,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.main.purchase,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.main.purchase = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.main.purchase = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.main.purchase = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Номер полиса ОСАГО")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main.number_osago_policy),
      expression: "main.number_osago_policy"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-number_osago_policy",
      "name": "main[number_osago_policy]"
    },
    domProps: {
      "value": _vm.main.number_osago_policy,
      "checked": Array.isArray(_vm.main.number_osago_policy) ? _vm._i(_vm.main.number_osago_policy, _vm.main.number_osago_policy) > -1 : (_vm.main.number_osago_policy)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.main.number_osago_policy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.main.number_osago_policy,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.main.number_osago_policy = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.main.number_osago_policy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.main.number_osago_policy = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Наименование страховой")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main.insurance_company_name),
      expression: "main.insurance_company_name"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-insurance_company_name",
      "name": "main[insurance_company_name]"
    },
    domProps: {
      "value": _vm.main.insurance_company_name,
      "checked": Array.isArray(_vm.main.insurance_company_name) ? _vm._i(_vm.main.insurance_company_name, _vm.main.insurance_company_name) > -1 : (_vm.main.insurance_company_name)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.main.insurance_company_name,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.main.insurance_company_name,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.main.insurance_company_name = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.main.insurance_company_name = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.main.insurance_company_name = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(15)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ПТС")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main.pts),
      expression: "main.pts"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-pts",
      "name": "main[pts]"
    },
    domProps: {
      "value": _vm.main.pts,
      "checked": Array.isArray(_vm.main.pts) ? _vm._i(_vm.main.pts, _vm.main.pts) > -1 : (_vm.main.pts)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.main.pts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.main.pts,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.main.pts = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.main.pts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.main.pts = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(16)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "equipment-bordered"
  }, [_c('table', {
    staticClass: "table table-striped striped-table-inspection"
  }, [_vm._m(17), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Тип салона")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.interior_type_id),
      expression: "equipment.interior_type_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-interior_type_id",
      "name": "equipment[interior_type_id]"
    },
    domProps: {
      "value": _vm.equipment.interior_type_id,
      "checked": Array.isArray(_vm.equipment.interior_type_id) ? _vm._i(_vm.equipment.interior_type_id, _vm.equipment.interior_type_id) > -1 : (_vm.equipment.interior_type_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.interior_type_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.interior_type_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.interior_type_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.interior_type_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.interior_type_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(18)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Цвет салона")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.color_id),
      expression: "equipment.color_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-color_id",
      "name": "equipment[color_id]"
    },
    domProps: {
      "value": _vm.equipment.color_id,
      "checked": Array.isArray(_vm.equipment.color_id) ? _vm._i(_vm.equipment.color_id, _vm.equipment.color_id) > -1 : (_vm.equipment.color_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.color_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.color_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.color_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.color_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.color_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(19)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Передние подушки безопасности")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.airbag_number_id),
      expression: "equipment.airbag_number_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-airbag_number_id",
      "name": "equipment[airbag_number_id]"
    },
    domProps: {
      "value": _vm.equipment.airbag_number_id,
      "checked": Array.isArray(_vm.equipment.airbag_number_id) ? _vm._i(_vm.equipment.airbag_number_id, _vm.equipment.airbag_number_id) > -1 : (_vm.equipment.airbag_number_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.airbag_number_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.airbag_number_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.airbag_number_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.airbag_number_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.airbag_number_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(20)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Боковые подушки безопасности")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.side_airbag_number_id),
      expression: "equipment.side_airbag_number_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-side_airbag_number_id",
      "name": "equipment[side_airbag_number_id]"
    },
    domProps: {
      "value": _vm.equipment.side_airbag_number_id,
      "checked": Array.isArray(_vm.equipment.side_airbag_number_id) ? _vm._i(_vm.equipment.side_airbag_number_id, _vm.equipment.side_airbag_number_id) > -1 : (_vm.equipment.side_airbag_number_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.side_airbag_number_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.side_airbag_number_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.side_airbag_number_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.side_airbag_number_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.side_airbag_number_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(21)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ABS")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.abs),
      expression: "equipment.abs"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-abs",
      "name": "equipment[abs]"
    },
    domProps: {
      "value": _vm.equipment.abs,
      "checked": Array.isArray(_vm.equipment.abs) ? _vm._i(_vm.equipment.abs, _vm.equipment.abs) > -1 : (_vm.equipment.abs)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.abs,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.abs,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.abs = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.abs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.abs = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(22)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Антипробуксовочная система")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.anti_slip_system),
      expression: "equipment.anti_slip_system"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-anti_slip_system",
      "name": "equipment[anti_slip_system]"
    },
    domProps: {
      "value": _vm.equipment.anti_slip_system,
      "checked": Array.isArray(_vm.equipment.anti_slip_system) ? _vm._i(_vm.equipment.anti_slip_system, _vm.equipment.anti_slip_system) > -1 : (_vm.equipment.anti_slip_system)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.anti_slip_system,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.anti_slip_system,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.anti_slip_system = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.anti_slip_system = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.anti_slip_system = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(23)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Система курсовой устойчивости")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.stability_control),
      expression: "equipment.stability_control"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-stability_control",
      "name": "equipment[stability_control]"
    },
    domProps: {
      "value": _vm.equipment.stability_control,
      "checked": Array.isArray(_vm.equipment.stability_control) ? _vm._i(_vm.equipment.stability_control, _vm.equipment.stability_control) > -1 : (_vm.equipment.stability_control)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.stability_control,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.stability_control,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.stability_control = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.stability_control = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.stability_control = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(24)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Навигация")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.navigation),
      expression: "equipment.navigation"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-navigation",
      "name": "equipment[navigation]"
    },
    domProps: {
      "value": _vm.equipment.navigation,
      "checked": Array.isArray(_vm.equipment.navigation) ? _vm._i(_vm.equipment.navigation, _vm.equipment.navigation) > -1 : (_vm.equipment.navigation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.navigation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.navigation,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.navigation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.navigation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.navigation = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(25)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Мультируль")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.multi_steering),
      expression: "equipment.multi_steering"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-multi_steering",
      "name": "equipment[multi_steering]"
    },
    domProps: {
      "value": _vm.equipment.multi_steering,
      "checked": Array.isArray(_vm.equipment.multi_steering) ? _vm._i(_vm.equipment.multi_steering, _vm.equipment.multi_steering) > -1 : (_vm.equipment.multi_steering)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.multi_steering,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.multi_steering,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.multi_steering = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.multi_steering = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.multi_steering = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(26)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Регулируемая рулевая колонка")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.steering_column_type_id),
      expression: "equipment.steering_column_type_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-steering_column_type_id",
      "name": "equipment[steering_column_type_id]"
    },
    domProps: {
      "value": _vm.equipment.steering_column_type_id,
      "checked": Array.isArray(_vm.equipment.steering_column_type_id) ? _vm._i(_vm.equipment.steering_column_type_id, _vm.equipment.steering_column_type_id) > -1 : (_vm.equipment.steering_column_type_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.steering_column_type_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.steering_column_type_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.steering_column_type_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.steering_column_type_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.steering_column_type_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(27)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Датчик света")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.light_sensor),
      expression: "equipment.light_sensor"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-light_sensor",
      "name": "equipment[light_sensor]"
    },
    domProps: {
      "value": _vm.equipment.light_sensor,
      "checked": Array.isArray(_vm.equipment.light_sensor) ? _vm._i(_vm.equipment.light_sensor, _vm.equipment.light_sensor) > -1 : (_vm.equipment.light_sensor)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.light_sensor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.light_sensor,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.light_sensor = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.light_sensor = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.light_sensor = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(28)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Датчик дождя")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.rain_sensor),
      expression: "equipment.rain_sensor"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-rain_sensor",
      "name": "equipment[rain_sensor]"
    },
    domProps: {
      "value": _vm.equipment.rain_sensor,
      "checked": Array.isArray(_vm.equipment.rain_sensor) ? _vm._i(_vm.equipment.rain_sensor, _vm.equipment.rain_sensor) > -1 : (_vm.equipment.rain_sensor)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.rain_sensor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.rain_sensor,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.rain_sensor = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.rain_sensor = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.rain_sensor = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(29)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Круиз-контроль")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.cruise_control),
      expression: "equipment.cruise_control"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-cruise_control",
      "name": "equipment[cruise_control]"
    },
    domProps: {
      "value": _vm.equipment.cruise_control,
      "checked": Array.isArray(_vm.equipment.cruise_control) ? _vm._i(_vm.equipment.cruise_control, _vm.equipment.cruise_control) > -1 : (_vm.equipment.cruise_control)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.cruise_control,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.cruise_control,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.cruise_control = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.cruise_control = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.cruise_control = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(30)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Тип климатической установки")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.ac_type_id),
      expression: "equipment.ac_type_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-ac_type_id",
      "name": "equipment[ac_type_id]"
    },
    domProps: {
      "value": _vm.equipment.ac_type_id,
      "checked": Array.isArray(_vm.equipment.ac_type_id) ? _vm._i(_vm.equipment.ac_type_id, _vm.equipment.ac_type_id) > -1 : (_vm.equipment.ac_type_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.ac_type_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.ac_type_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.ac_type_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.ac_type_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.ac_type_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(31)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Количество зон климат контроля")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.ac_zone_id),
      expression: "equipment.ac_zone_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-ac_zone_id",
      "name": "equipment[ac_zone_id]"
    },
    domProps: {
      "value": _vm.equipment.ac_zone_id,
      "checked": Array.isArray(_vm.equipment.ac_zone_id) ? _vm._i(_vm.equipment.ac_zone_id, _vm.equipment.ac_zone_id) > -1 : (_vm.equipment.ac_zone_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.ac_zone_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.ac_zone_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.ac_zone_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.ac_zone_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.ac_zone_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(32)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Обогрев лобового стекла")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.glass_heat_type_id),
      expression: "equipment.glass_heat_type_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-glass_heat_type_id",
      "name": "equipment[glass_heat_type_id]"
    },
    domProps: {
      "value": _vm.equipment.glass_heat_type_id,
      "checked": Array.isArray(_vm.equipment.glass_heat_type_id) ? _vm._i(_vm.equipment.glass_heat_type_id, _vm.equipment.glass_heat_type_id) > -1 : (_vm.equipment.glass_heat_type_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.glass_heat_type_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.glass_heat_type_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.glass_heat_type_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.glass_heat_type_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.glass_heat_type_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(33)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Электропривод сидений")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.electric_seats_type_id),
      expression: "equipment.electric_seats_type_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-electric_seats_type_id",
      "name": "equipment[electric_seats_type_id]"
    },
    domProps: {
      "value": _vm.equipment.electric_seats_type_id,
      "checked": Array.isArray(_vm.equipment.electric_seats_type_id) ? _vm._i(_vm.equipment.electric_seats_type_id, _vm.equipment.electric_seats_type_id) > -1 : (_vm.equipment.electric_seats_type_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.electric_seats_type_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.electric_seats_type_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.electric_seats_type_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.electric_seats_type_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.electric_seats_type_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(34)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Память сидений")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.memory_seats_type_id),
      expression: "equipment.memory_seats_type_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-memory_seats_type_id",
      "name": "equipment[memory_seats_type_id]"
    },
    domProps: {
      "value": _vm.equipment.memory_seats_type_id,
      "checked": Array.isArray(_vm.equipment.memory_seats_type_id) ? _vm._i(_vm.equipment.memory_seats_type_id, _vm.equipment.memory_seats_type_id) > -1 : (_vm.equipment.memory_seats_type_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.memory_seats_type_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.memory_seats_type_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.memory_seats_type_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.memory_seats_type_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.memory_seats_type_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(35)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Вентиляция сидений")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.vent_seats_type_id),
      expression: "equipment.vent_seats_type_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-vent_seats_type_id",
      "name": "equipment[vent_seats_type_id]"
    },
    domProps: {
      "value": _vm.equipment.vent_seats_type_id,
      "checked": Array.isArray(_vm.equipment.vent_seats_type_id) ? _vm._i(_vm.equipment.vent_seats_type_id, _vm.equipment.vent_seats_type_id) > -1 : (_vm.equipment.vent_seats_type_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.vent_seats_type_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.vent_seats_type_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.vent_seats_type_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.vent_seats_type_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.vent_seats_type_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(36)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Подогрев сидений")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.seats_heat_type_id),
      expression: "equipment.seats_heat_type_id"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-seats_heat_type_id",
      "name": "equipment[seats_heat_type_id]"
    },
    domProps: {
      "value": _vm.equipment.seats_heat_type_id,
      "checked": Array.isArray(_vm.equipment.seats_heat_type_id) ? _vm._i(_vm.equipment.seats_heat_type_id, _vm.equipment.seats_heat_type_id) > -1 : (_vm.equipment.seats_heat_type_id)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.seats_heat_type_id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.seats_heat_type_id,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.seats_heat_type_id = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.seats_heat_type_id = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.seats_heat_type_id = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(37)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Электростеклоподъемники")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.power_windows),
      expression: "equipment.power_windows"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-power_windows",
      "name": "equipment[power_windows]"
    },
    domProps: {
      "value": _vm.equipment.power_windows,
      "checked": Array.isArray(_vm.equipment.power_windows) ? _vm._i(_vm.equipment.power_windows, _vm.equipment.power_windows) > -1 : (_vm.equipment.power_windows)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.power_windows,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.power_windows,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.power_windows = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.power_windows = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.power_windows = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(38)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Обогрев зеркал")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.heated_mirrors),
      expression: "equipment.heated_mirrors"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-heated_mirrors",
      "name": "equipment[heated_mirrors]"
    },
    domProps: {
      "value": _vm.equipment.heated_mirrors,
      "checked": Array.isArray(_vm.equipment.heated_mirrors) ? _vm._i(_vm.equipment.heated_mirrors, _vm.equipment.heated_mirrors) > -1 : (_vm.equipment.heated_mirrors)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.heated_mirrors,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.heated_mirrors,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.heated_mirrors = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.heated_mirrors = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.heated_mirrors = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(39)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Электропривод зеркал")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.power_mirrors),
      expression: "equipment.power_mirrors"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-power_mirrors",
      "name": "equipment[power_mirrors]"
    },
    domProps: {
      "value": _vm.equipment.power_mirrors,
      "checked": Array.isArray(_vm.equipment.power_mirrors) ? _vm._i(_vm.equipment.power_mirrors, _vm.equipment.power_mirrors) > -1 : (_vm.equipment.power_mirrors)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.power_mirrors,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.power_mirrors,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.power_mirrors = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.power_mirrors = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.power_mirrors = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(40)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Электроскладывание зеркал")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.electric_folding_mirrors),
      expression: "equipment.electric_folding_mirrors"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-electric_folding_mirrors",
      "name": "equipment[electric_folding_mirrors]"
    },
    domProps: {
      "value": _vm.equipment.electric_folding_mirrors,
      "checked": Array.isArray(_vm.equipment.electric_folding_mirrors) ? _vm._i(_vm.equipment.electric_folding_mirrors, _vm.equipment.electric_folding_mirrors) > -1 : (_vm.equipment.electric_folding_mirrors)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.electric_folding_mirrors,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.electric_folding_mirrors,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.electric_folding_mirrors = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.electric_folding_mirrors = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.electric_folding_mirrors = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(41)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Пневматическая подвеска")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipment.air_suspension),
      expression: "equipment.air_suspension"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id-air_suspension",
      "name": "equipment[air_suspension]"
    },
    domProps: {
      "value": _vm.equipment.air_suspension,
      "checked": Array.isArray(_vm.equipment.air_suspension) ? _vm._i(_vm.equipment.air_suspension, _vm.equipment.air_suspension) > -1 : (_vm.equipment.air_suspension)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.equipment.air_suspension,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.equipment.air_suspension,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.equipment.air_suspension = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.equipment.air_suspension = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.equipment.air_suspension = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(42)])])])])])])]), _vm._v(" "), _vm._m(43)])])])]) : _c('h3', [_vm._v("Загрузка салонов ...")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-first_name"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-second_name"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-middle_name"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-email"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-phone"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-diagnostics"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-seat_count"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-main_color_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-engine_capacity"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-number_owners"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-guarantee"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-purchase"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-number_osago_policy"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-insurance_company_name"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-pts"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-interior_type_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-color_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-airbag_number_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-side_airbag_number_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-abs"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-anti_slip_system"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-stability_control"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-navigation"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-multi_steering"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-steering_column_type_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-light_sensor"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-rain_sensor"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-cruise_control"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-ac_type_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-ac_zone_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-glass_heat_type_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-electric_seats_type_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-memory_seats_type_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-vent_seats_type_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-seats_heat_type_id"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-power_windows"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-heated_mirrors"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-power_mirrors"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-electric_folding_mirrors"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "id-air_suspension"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-cancel btn-sm",
    attrs: {
      "href": "/home"
    }
  }, [_vm._v("Отмена")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db77e610", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db77e610"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TabsRequiredFields.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-db77e610"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TabsRequiredFields.vue
// module chunks = 0